<template>
  <v-item v-slot="{ active, toggle }" v-ripple="{ class: 'primary--text' }" :value="suggestion" :color="isActive ? 'primary accent-3' : ''">
    <v-card class="suggested-amount-card text-center" width="110" height="65" outlined :class="{ active }" @click="toggle">
      <div class="d-flex flex-column pa-2 fill-height justify-center" :title="suggestion.fullDescription || suggestion.description">
        <span class="headline">{{ suggestion.amount }} {{ currency.unit }}</span>
        <span v-if="isOtherAmount" class="d-inline-block caption">{{ t("AUTRE_MONTANT") }}</span>
      </div>
    </v-card>
  </v-item>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  props: {
    suggestion: {
      type: Object,
      required: true
    },
    isRecurringDonation: {
      type: Boolean,
      default: false
    },
    isOtherAmount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    ...mapGetters(["formParams", "currency", "t"])
  }
}
</script>

<style scoped>
.active {
  border-color: var(--v-primary-base) !important;
  color: var(--v-primary-base) !important;
}
</style>